import { render, staticRenderFns } from "./fdacontent.vue?vue&type=template&id=b73418e0&"
import script from "./fdacontent.vue?vue&type=script&lang=js&"
export * from "./fdacontent.vue?vue&type=script&lang=js&"
import style0 from "./fdacontent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports